import { Alert, Card, Col, ConfigProvider, Divider, Form, Row, Statistic, Typography, Select } from "antd";
import SDIModal from "../../../../components/ui/SDIModal";
import PropTypes from "prop-types";
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../../variables/api/axiosInstance";

const { Text, Title } = Typography;
const { Option } = Select;

const Duplicata = (props) => {
    const [modalDuplicata, setModalDuplicata] = useState(props.open);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    // États pour les données du contrat et du duplicata
    const [contratActuel, setContratActuel] = useState(null);
    const [documentsSelectionnes, setDocumentsSelectionnes] = useState([]);
    const [vehiculesSelectionnes, setVehiculesSelectionnes] = useState([]);
    const [fraisDuplicata, setFraisDuplicata] = useState(0);

    useEffect(() => {
        setModalDuplicata(props.open);
        if (props.open && props?.contrat?.codeId) {
            console.log("Contrat pour duplicata:", props?.contrat);
            setContratActuel(props?.contrat);

            // Déterminer la catégorie du véhicule et les frais
            const vehicules = props?.contrat?.engins || [];
            if (vehicules.length > 0) {
                axiosInstance.get(`/api/avenant/accessoires/AD/${props?.contrat?.engins[0]?.categorie?.codeCategorie}`)
                    .then(response => {
                        setFraisDuplicata(response.data);
                    })
                    .catch(error => {
                        console.error("Erreur lors de la récupération des frais accessoires:", error);
                    });
            }

            // Pré-sélectionner les documents obligatoires
            setDocumentsSelectionnes(['attestation', 'vignette']);
        }
    }, [props.open, props?.contrat?.codeId]);

    const { FileTextOutlined, DollarOutlined, WarningOutlined } = require('@ant-design/icons');

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XAF' }).format(value);
    };

    // const handleDocumentsChange = (checkedValues) => {
    //     // S'assurer que les documents obligatoires restent cochés
    //     const documentsObligatoires = documentsDisponibles
    //         .filter(doc => doc.obligatoire)
    //         .map(doc => doc.id);

    //     const nouveauxDocuments = [...new Set([...checkedValues, ...documentsObligatoires])];
    //     setDocumentsSelectionnes(nouveauxDocuments);
    // };

    const handleVehiculesChange = (selectedVehicules) => {
        setVehiculesSelectionnes(selectedVehicules);
    };

    const enterLoading = () => setLoading(true);
    const outLoading = () => setLoading(false);

    const handleDuplicataSubmit = async () => {
        try {
            await form.validateFields();

            // Vérifications
            if (documentsSelectionnes.length === 0) {
                toast.error("Veuillez sélectionner au moins un document à dupliquer");
                return;
            }

            if (vehiculesSelectionnes.length === 0) {
                toast.error("Veuillez sélectionner au moins un véhicule");
                return;
            }

            enterLoading();

            const payload = {
                codeId: contratActuel.codeId,
                accessoires: fraisDuplicata * vehiculesSelectionnes.length,
                taxes: (fraisDuplicata * vehiculesSelectionnes.length) * 0.06,
                primeTotale: (fraisDuplicata * vehiculesSelectionnes.length) * 1.06 };

            console.log("Payload duplicata:", payload);

            const response = await axiosInstance.put(
                `/api/contrat/duplicata`,
                payload
            );

            toast.success("Duplicata généré avec succès!");
            setModalDuplicata(false);
            props.update(false);
            window.location.reload();

        } catch (error) {
            console.error(error);
            toast.error("Erreur lors de la génération du duplicata");
        } finally {
            outLoading();
        }
    };

    const handleCancel = () => {
        setModalDuplicata(false);
        props.update(false);
    };

    const isContratValide = () => {
        return contratActuel?.statut !== 'EXPIRE' &&
            contratActuel?.statut !== 'RESILIE';
    };

    const calculateTotal = () => {
        // Frais par véhicule sélectionné
        return fraisDuplicata * vehiculesSelectionnes.length;
    };

    return (
        <SDIModal
            title="AVENANT DE DUPLICATA"
            centered
            confirmLoading={loading}
            open={modalDuplicata}
            onOk={handleDuplicataSubmit}
            onCancel={handleCancel}
            width={1100}
            zIndex={1940}
            okText="Générer le duplicata"
            cancelText="Annuler"
        >
            <ConfigProvider locale={frFR}>
                <div className="duplicata-content">

                    {/* Informations sur le contrat */}
                    {contratActuel && (
                        <Card className="mb-4" size="small" title="Contrat concerné">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Statistic
                                        title="Numéro de police"
                                        value={contratActuel.numeroPoliceP || contratActuel.numeroPoliceM}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic
                                        title="Catégorie véhicule"
                                        value={contratActuel?.engins && contratActuel?.engins[0]?.categorie?.nom}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Statistic
                                        title="Frais accessoires"
                                        value={formatCurrency(fraisDuplicata)}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    )}

                    {/* Statut du contrat */}
                    {!isContratValide() ? (
                        <Alert
                            message="Contrat non valide"
                            description="Le duplicata ne peut être généré que pour des contrats actifs (non expirés, non résiliés)."
                            type="error"
                            icon={<WarningOutlined />}
                            showIcon
                            className="mb-4"
                        />
                    ) : null}

                    {/* Informations sur le duplicata */}
                    {/* <Card className="mb-4" size="small" title="Informations importantes">
                        <div className="info-section">
                            <div className="info-item">
                                <InfoCircleOutlined className="info-icon info" />
                                <Text>
                                    <Text strong>Code avenant :</Text> AD + Année + 001 (premier duplicata de l'année)
                                </Text>
                            </div>
                            <div className="info-item">
                                <DollarOutlined className="info-icon warning" />
                                <Text>
                                    <Text strong>Tarification :</Text> 5 300 XAF pour TPV / 2 120 XAF pour 2/3 roues (par véhicule)
                                </Text>
                            </div>
                            <div className="info-item">
                                <CopyOutlined className="info-icon success" />
                                <Text>
                                    <Text strong>Documents :</Text> Réimpression d'attestations et documents d'assurance
                                </Text>
                            </div>
                        </div>
                    </Card> */}

                    <Form form={form} layout="vertical">
                        {/* Sélection des véhicules */}
                        <Form.Item
                            label="Véhicules concernés"
                            name="vehicules"
                            rules={[{ required: true, message: 'Veuillez sélectionner au moins un véhicule' }]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Sélectionner les véhicules pour lesquels générer le duplicata"
                                onChange={handleVehiculesChange}
                                style={{ width: '100%' }}
                            >
                                {contratActuel?.engins?.map(vehicule => (
                                    <Option key={vehicule.codeId} value={vehicule.codeId}>
                                        <div className="vehicule-option">
                                            <Text strong>{vehicule.immatriculation}</Text>
                                            <Text type="secondary" className="ml-2">
                                                {vehicule.marque} - {vehicule.type}
                                            </Text>
                                        </div>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>


                        {/* Récapitulatif si des véhicules sont sélectionnés */}
                        {vehiculesSelectionnes.length > 0 && (
                            <Card className="mb-4" size="small" title="Récapitulatif de la demande">
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Statistic
                                            title="Nombre de véhicules"
                                            value={vehiculesSelectionnes.length}
                                            prefix={<FileTextOutlined />}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Statistic
                                            title="Documents à réimprimer"
                                            value={documentsSelectionnes.length}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Statistic
                                            title="Frais unitaires"
                                            value={formatCurrency(fraisDuplicata)}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        )}

                        {/* Récapitulatif financier */}
                        {vehiculesSelectionnes.length > 0 && (
                            <Card className="cost-summary" size="small">
                                <Title level={5}>
                                    <DollarOutlined className="mr-2" />
                                    Récapitulatif financier
                                </Title>
                                <div className="cost-breakdown">
                                    <Row justify="space-between" className="cost-line">
                                        <Col>
                                            <Text>Nombre de véhicules:</Text>
                                        </Col>
                                        <Col>
                                            <Text strong>{vehiculesSelectionnes.length}</Text>
                                        </Col>
                                    </Row>

                                    <Row justify="space-between" className="cost-line">
                                        <Col>
                                            <Text>Frais par véhicule:</Text>
                                        </Col>
                                        <Col>
                                            <Text>{formatCurrency(fraisDuplicata)}</Text>
                                        </Col>
                                    </Row>

                                    <Row justify="space-between" className="cost-line">
                                        <Col>
                                            <Text>Taxes: </Text>
                                        </Col>
                                        <Col>
                                            <Text>{formatCurrency(fraisDuplicata * vehiculesSelectionnes.length * 0.06)}</Text>
                                        </Col>
                                    </Row>

                                    <Divider className="my-2" />

                                    <Row justify="space-between" className="cost-line total-cost">
                                        <Col>
                                            <Text strong className="text-lg">MONTANT TOTAL À PAYER:</Text>
                                        </Col>
                                        <Col>
                                            <Text strong className="text-lg text-blue-600">
                                                {formatCurrency(calculateTotal() * 1.06)}
                                            </Text>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        )}
                    </Form>
                </div>
            </ConfigProvider>

            <style jsx>
                {`
                    .duplicata-content {
                        max-height: 70vh;
                        overflow-y: auto;
                    }
                    
                    .info-section {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }
                    
                    .info-item {
                        display: flex;
                        align-items: flex-start;
                        gap: 8px;
                    }
                    
                    .info-icon {
                        margin-top: 2px;
                        font-size: 16px;
                    }
                    
                    .info-icon.warning {
                        color: #faad14;
                    }
                    
                    .info-icon.info {
                        color: #1890ff;
                    }
                    
                    .info-icon.success {
                        color: #52c41a;
                    }
                    
                    .vehicule-option {
                        display: flex;
                        align-items: center;
                    }
                    
                    .cost-summary {
                        background-color: #f8f9fa;
                        border: 1px solid #e9ecef;
                    }
                    
                    .cost-breakdown .cost-line {
                        margin-bottom: 8px;
                    }
                    
                    .cost-breakdown .total-cost {
                        background-color: #e6f7ff;
                        padding: 8px;
                        border-radius: 4px;
                        margin-top: 8px;
                    }
                    
                    .ml-2 { margin-left: 8px; }
                    .mr-2 { margin-right: 8px; }
                    .mb-4 { margin-bottom: 16px; }
                    .my-2 { margin: 8px 0; }
                    .text-lg { font-size: 16px; }
                    .text-blue-600 { color: #1890ff; }
                `}
            </style>
        </SDIModal>
    );
};

Duplicata.propTypes = {
    open: PropTypes.bool,
    update: PropTypes.func,
    contrat: PropTypes.object
};

export default Duplicata;